module.exports = __webpack_public_path__ + "img/collaborate-detail-1.a730159f.png";